import { css } from 'react-emotion'

const styles = {
  header: css({
    margin: '24px 16px',
    fontSize: '1.4rem'
  }),
  collaboratorSlab: css({
    padding: '8px 16px'
  }),

  collaboratorIdentity: css({
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '88%'
  }),

}

export default styles



// WEBPACK FOOTER //
// ./src/Components/SideBarRightStyles.js